const url = 'http://192.168.18.3:8000';

module.exports = {
    url
}